import React, { useState, useEffect } from "react";
import { useAuthPageForm } from "../hooks/useAuthPageForm.js";
import AuthPageHero from "../components/auth/AuthPageHero.jsx";
import AuthFormCard from "../components/auth/AuthFormCard.jsx";
import ForgotPasswordForm from "../components/auth/ForgotPasswordForm.jsx";
import LanguageSelector from "../components/common/LanguageSelector.jsx";
import AppLoadingScreen from "../components/common/AppLoadingScreen.jsx";
import { foodAccueil, patesBg } from "../assets/images.js";

/**
 * Page d'authentification dédiée — même fond et palette que VisitorHome (slate + orange/ambre)
 */
const AuthPage = () => {
  const auth = useAuthPageForm();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const preload = (src) =>
      new Promise((resolve) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = resolve;
        img.src = src;
      });
    Promise.all([
      preload(foodAccueil),
      preload(patesBg),
      preload(
        process.env.PUBLIC_URL
          ? `${process.env.PUBLIC_URL}/logojes.png`
          : "/logojes.png",
      ),
    ]).finally(() => setIsReady(true));
  }, []);

  if (!isReady) {
    return (
      <AppLoadingScreen
        message="Chargement..."
        subMessage="Préparation de la page de connexion"
      />
    );
  }

  return (
    <div className="min-h-screen bg-slate-900 relative overflow-hidden">
      <div className="absolute top-4 right-4 z-20">
        <LanguageSelector />
      </div>
      <div
        className="fixed inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${foodAccueil})` }}
        aria-hidden
      />
      <div className="fixed inset-0 z-0 bg-slate-900/40" aria-hidden />

      {auth.showForgotPassword && (
        <ForgotPasswordForm
          onBack={auth.closeForgotPassword}
          onClose={auth.closeForgotPassword}
        />
      )}

      <div className="relative z-10 min-h-screen flex items-center justify-center p-4 sm:p-6 lg:p-8">
        <div className="w-full max-w-7xl grid grid-cols-1 md:grid-cols-[45%_55%] gap-6 sm:gap-8 md:gap-10 items-center">
          <AuthPageHero />
          <AuthFormCard {...auth} onForgotPassword={auth.openForgotPassword} />
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
